import { format, getMonth, getYear, parseISO } from "date-fns";

export function getFinancialYear(dateStr) {
  const d = parseISO(dateStr);
  const yr = getYear(d);
  const year = getMonth(d) >= 3 ? yr : yr - 1; // FY starts in April
  return `FY ${year}-${year + 1}`;
}

export function formatMonthRange(startStr, endStr) {
  const start = parseISO(startStr);
  const end = parseISO(endStr);
  const startMonth = format(start, "LLLL");
  const endMonth = format(end, "LLLL");
  return `${startMonth} - ${endMonth}`;
}

export const getPerformanceEmoji = (score) => {
  // Ensure score is within valid range (0-7)
  const normalizedScore = Math.max(0, Math.min(7, Math.floor(score)));

  const emojiMap = {
    1: "😭", // Never
    2: "😬", // Rarely
    3: "😶", // Sometimes
    4: "🙂", // Often
    5: "😁", // Usually
    6: "😃", // Almost Always
    7: "🏅", // Gold Standard
  };

  return emojiMap[normalizedScore] ; // Default to question mark if score is invalid
};

export const getPerformanceText = (score) => {
  // Ensure score is within valid range (0-7)
  const normalizedScore = Math.max(0, Math.min(7, Math.floor(score)));

  const textMap = {
    1: "Never",
    2: "Rarely",
    3: "Sometimes",
    4: "Often",
    5: "Usually",
    6: "Almost Always",
    7: "Gold Standard",
  };

  return textMap[normalizedScore] || "Not Observed";
};
